module.exports = __webpack_public_path__ + "static/img/Annette-Clayton_2017-18.2ce27b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/leadership/Annette-Clayton_2017-18.jpg
// module id = GXg+
// module chunks = 0